/* 
 * @description: 
 * @author: Jason Wong 
 * @since: 2020-05-12 17:41:28 
 */

import axios from "axios";
import { defHttp } from "../utils/http/axios";

function makeQuery(url, data) {
  let res = url;
  let hasQuerySymbolAdded = false;
  for (const key in data) {
    if (data[key] == null) continue;

    if (!hasQuerySymbolAdded) {
      res += "?";
      hasQuerySymbolAdded = true;
    } else {
      res += "&";
    }
    res += `${key}=${decodeURIComponent(data[key])}`;
  }
  return res;
}

async function get(url, data) {
  return defHttp.get({url,params:data});
}

async function getWithCancelToken(url, data, token) {
  const response = await axios.get(makeQuery(url, data), { cancelToken: token });
  if (!response.data.success) throw response.data.error;
  return response.data.data;
}

async function post(url, data) {
  return defHttp.post({url,data});
}

async function postWithCancelToken(url, data, token) {
  const response = await axios.post(url, data, { cancelToken: token });
  if (!response.data.success) throw response.data.error;
  return response.data.data;
}

export { makeQuery, get, getWithCancelToken, post, postWithCancelToken };
